import { bl_fi_mst_entity_to_entity_subsidiary_link_RowClass } from '../../../dbschema/bl_fi_mst_entity_to_entity_subsidiary_link.model';
import { BaseContainerModel } from '../../base-container.model';

export class EntitySubsidiaryLinkContainer extends BaseContainerModel{
    bl_fi_mst_entity_to_entity_subsidiary_link: bl_fi_mst_entity_to_entity_subsidiary_link_RowClass = new bl_fi_mst_entity_to_entity_subsidiary_link_RowClass();
}